/**
 * App-level provider composition.
 *
 * The app is 100 % offline and account-free: the only async startup
 * resource is the lingui catalog. AudioProvider (M1) and SettingsProvider
 * (M2) will be added here.
 */

import type { ParentComponent } from "solid-js";

import { I18nProvider } from "@/providers/i18n-provider";
import { AudioProvider } from "@/providers/audio-provider";
import { ConfigProvider } from "@/providers/config-provider";
import { SettingsProvider } from "@/providers/settings-provider";
import { KernelProvider } from "@/providers/kernel-provider";

// `ConfigProvider` goes OUTSIDE audio and settings: the app configuration
// (difficulty, narration, parental gate, capping) is what both consume.
export const AppProviders: ParentComponent = (props) => (
  <I18nProvider>
    <KernelProvider>
      <ConfigProvider>
        <SettingsProvider>
          <AudioProvider>{props.children}</AudioProvider>
        </SettingsProvider>
      </ConfigProvider>
    </KernelProvider>
  </I18nProvider>
);
